module.exports = __webpack_public_path__ + "img/xiongan01.b92aef34.png";